import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map, tap } from 'rxjs/operators';
import {
    openConfirmationDialog,
    openConfirmationDialogCancelled,
    openConfirmationDialogConfirmed,
    resetDialogState
} from 'src/app/shared/actions/confirmation-dialog.actions';
import { ConfirmDialogService } from 'src/app/shared/services/confirm-dialog.service';

@Injectable()
export class ConfirmationDialogEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _store: Store,
        private readonly _confirmationDialogService: ConfirmDialogService
    ) {}

    openConfirmationDialog$ = createEffect(() =>
        this._actions$.pipe(
            ofType(openConfirmationDialog),
            exhaustMap((action) =>
                this._confirmationDialogService.showDialog(action.settings).pipe(
                    map((result) => {
                        if (result) {
                            return openConfirmationDialogConfirmed({
                                result: result,
                                data: action.settings?.addtlData ?? undefined
                            });
                        } else {
                            return openConfirmationDialogCancelled({ canceled: false });
                        }
                    })
                )
            )
        )
    );

    resetConfirmationDialog$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(openConfirmationDialogConfirmed),
                tap(() => this._store.dispatch(resetDialogState()))
            ),
        { dispatch: false }
    );
}
